import { Location } from "history";
import IntegrationsChannelsWrapper from "../../integrations/wrapper";

export default function AiIntegrations (props: { location: Location; }) {
  return (
    <div className="flex flex-column gap-4 w-100 h-100 pb-4 px-4 overflow-y-scroll">
      <IntegrationsChannelsWrapper
        mode="location"
        location={props.location}
        showHeader={false}
      />
    </div>
  )
}
